// Promo-binding v2: the picked waitlist rides the URL (?waitlist=<promoId>).
// A wave link then survives a reload and a share: the page lands on the
// linked waitlist instead of the service default, and the wave is there.
export const withWaitlist = (path, waitlistId) =>
  waitlistId ? `${path}?waitlist=${encodeURIComponent(waitlistId)}` : path;

export const wavePath = (waitlistId, waveId, tab) =>
  withWaitlist(`/waitlist/waves/${waveId}${tab ? `/${tab}` : ''}`, waitlistId);
